<script>
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import { groupsMethods, euroCouponsTypesMethods } from "@state/helpers";
import { required, minLength } from "vuelidate/lib/validators";
import GroupsCreateForm from "@views/roles_management/groups/create-form";
import GroupsUpdateForm from "@views/roles_management/groups/update-form";
import CuoponTypesCreateForm from "@views/roles_management/coupon_types/create";
import CuponsTypesMultiselect from "@components/euro_coupons/coupon_types/Select";
export default {
  page: {
    title: "Groups",
    meta: [{ name: "Groups management", content: "Groups management" }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    GroupsCreateForm,
    GroupsUpdateForm,
    CuoponTypesCreateForm,
    CuponsTypesMultiselect,
  },
  data() {
    return {
      title: this.$t("Tipos de Bonos"),
      items: [
        {
          text: this.$t("home"),
          href: "/",
        },
        {
          text: this.$t("management"),
        },
        {
          text: this.$t("Tipos de Bonos"),
          active: true,
        },
      ],
      tableHeaders: [
        {
          key: "name",
          sortable: true,
          label: this.$t("name"),
        },
        {
          key: "amount",
          label: this.$t("amount"),
          sortable: true,
        },
        {
          key: "periodicity_generation",
          label: this.$t("periodicity_generation"),
        },
        {
          key: "antiquity_condition",
          label: this.$t("antiquity_condition"),
        },
        {
          key: "time_to_ejecution",
          label: this.$t("time_to_ejecution"),
        },
        {
          key: "time_to_claim",
          label: this.$t("time_to_claim"),
        },
        {
          key: "ejecution_date",
          label: this.$t("ejecution_date"),
        },
        {
          key: "actions",
          label: this.$t("actions"),
        },
      ],
      action: "",
      newItem: {
        name: null,
        initial_task_date: null,
        end_task_date: null,
        time_to_claim_months: 0,
        periodicity_generation_days: 0,
        periodicity_generation_months: 0,
        antiquity_condition_months: 0,
        time_to_ejecution_weeks: 0,
        time_to_ejecution_months: 0,
        amount: 0,
      },

      toDelete: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      actionsLoadings: {},
      filters: {
        id: null,
        antiquity_condition_months: null,
      },
    };
  },

  methods: {
    ...groupsMethods,
    ...euroCouponsTypesMethods,
    myProvider(ctx) {
      ctx = this.$table_params(ctx);
      ctx += this.filterset ? `&${this.filterset}` : "";
      const promise = this.fetchEuroCouponsTypes(ctx);
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          return [];
        });
    },
    // openDetailModal(item, index, button) {
    //   let context = this;
    //   context.isSubmitting = true;
    //   context.actionsLoadings[button] = true;
    //   context.detailModal.title = `${this.$t("group")}: ${item.name}`;
    //   const promise = context.fetchGroupsDetail(item.url);
    //   return promise
    //     .then((data) => {
    //       context.detailModal.content = data;
    //       context.detailModalShow = !context.detailModalShow;
    //       context.isSubmitting = false;
    //       context.actionsLoadings[button] = false;
    //     })
    //     .catch((error) => {
    //       context.$axios_error_noty(error, context);
    //       context.isSubmitting = false;
    //       context.actionsLoadings[button] = false;
    //     });
    // },
    // resetdetailModal() {
    //   this.detailModal.title = "";
    //   this.detailModal.content = "";
    // },
    // resetCreateUpdateModal(action) {
    //   this.createUpdateModal.title = "";
    //   if (action === "create") {
    //     this.createForm.name = "";
    //     this.createForm.description = "";
    //     this.createForm.user_set = [];
    //     this.updateForm.permissions = [];
    //     this.$v.createForm.$reset();
    //   } else {
    //     this.updateForm.name = "";
    //     this.updateForm.description = "";
    //     this.updateForm.user_set = [];
    //     this.updateForm.permissions = [];
    //     this.$v.updateForm.$reset();
    //   }
    // },
    openCreateUpdateModal(item, index, action) {
      this.createUpdateModalShow = !this.createUpdateModalShow;
      this.clearItem();
    },
    clearItem() {
      this.newItem = {
        name: null,
        initial_task_date: null,
        end_task_date: null,
        time_to_claim_months: 0,
        periodicity_generation_days: 0,
        periodicity_generation_months: 0,
        antiquity_condition_months: 0,
        amount: 0,
        time_to_ejecution_weeks: 0,
        time_to_ejecution_months: 0,
      };
    },
    onFormSubmit() {
      const promise = this.createUpdateEuroCouponsTypes(this.newItem);
      return promise
        .then((data) => {
          if (this.newItem.url) {
            this.$generate_toast(this, "success", "Bono Actualizado Correctamente");
          } else {
            this.$generate_toast(this, "success", "Bono Creado Correctamente");
          }
          this.createUpdateModalShow = !this.createUpdateModalShow;
          this.$refs.table.refresh();
          this.isSubmitting = false;
          this.clearItem();
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
          this.isSubmitting = false;
        });
    },
    openDeleteModal(item, index) {
      let context = this;
      context.toDelete = item;
      context.deleteModalShow = !context.deleteModalShow;
    },
    resetDeleteModal(item, index) {
      this.toDelete = {};
    },
    deleteCouponType() {
      let context = this;
      context.isSubmitting = true;
      const promise = context.deleteEuroCouponsTypes(context.toDelete.url);
      return promise
        .then((data) => {
          context.$generate_toast(context, "success", "Cupon Eliminado Correctamente");
          context.$refs.table.refresh();
          context.isSubmitting = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
        });
    },
    setFilter(filter, value) {
      if (filter == "antiquity_condition_months") {
        if (!value) {
          this.clear();
        } else {
          this.filters[filter] = value;
        }
      } else {
        this.filters[filter] = value;
      }
    },

    filter() {
      this.$refs.table.lastFilter = "";
      this.$refs.table.onFiltered();
      setTimeout(() => this.$refs.table.refresh(), 200);
    },

    clear() {
      this.filters.id = null;
      this.filters.antiquity_condition_months = null;

      this.filterset = null;
      setTimeout(() => this.$refs.table.refresh(), 200);
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = [];
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`);
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join("&");
        }
        this.filter();
      },
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
              <b>{{ $t("filters") }}</b>
            </b-row>
            <b-row>
              <b-col md="3">
                <CuponsTypesMultiselect
                  :label="'Tipo de Bono'"
                  :value="filters.id"
                  @input="(value) => setFilter('id', value)"
                >
                </CuponsTypesMultiselect>
              </b-col>
              <b-col md="3">
                <p class="m-1 p-0" for="">Condición de antiguedad (Meses)</p>
                <b-form-input
                  :label="'Tipo de Bono'"
                  :value="filters.antiquity_condition_months"
                  @input="(value) => setFilter('antiquity_condition_months', value)"
                >
                </b-form-input>
              </b-col>

              <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">
                <!-- <b-button
                  class="ml-1 rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="filter"
                  ><i class="fas fa-filter"></i>
                </b-button> -->
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="clear"
                  ><i class="fas fa-eraser"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:buttons>
                <b-button
                  variant="outline-primary rounded-lg shadow-sm"
                  size="sm"
                  @click="openCreateUpdateModal(null, null, 'create')"
                >
                  <i class="fas fa-plus"></i>
                </b-button>
              </template>
              <template v-slot:cell(periodicity_generation)="row">
                <p class="m-0 p-0">
                  {{
                    row.item.periodicity_generation_days != 0
                      ? `${row.item.periodicity_generation_days} Dias `
                      : ""
                  }}
                  {{
                    row.item.periodicity_generation_months != 0
                      ? row.item.periodicity_generation_months == 1
                        ? `${row.item.periodicity_generation_months} Mes`
                        : `${row.item.periodicity_generation_months} Meses`
                      : ""
                  }}
                </p>
              </template>
              <template v-slot:cell(amount)="row">
                <p class="p-0 m-0">
                  {{ $formatDollar(row.item.amount) }}
                </p>
              </template>
              <template v-slot:cell(antiquity_condition)="row">
                <p class="m-0 p-0">
                  {{
                    row.item.antiquity_condition_months != 0
                      ? row.item.antiquity_condition_months == 1
                        ? `${row.item.antiquity_condition_months} Mes`
                        : `${row.item.antiquity_condition_months} Meses`
                      : ""
                  }}
                </p>
              </template>
              <template v-slot:cell(time_to_ejecution)="row">
                <p class="m-0 p-0">
                  {{
                    row.item.time_to_ejecution_weeks != 0
                      ? row.item.time_to_ejecution_weeks == 1
                        ? `${row.item.time_to_ejecution_weeks} Semana `
                        : `${row.item.time_to_ejecution_weeks} Semanas `
                      : ""
                  }}
                  {{
                    row.item.time_to_ejecution_months != 0
                      ? row.item.time_to_ejecution_months == 1
                        ? `${row.item.time_to_ejecution_months} Mes`
                        : `${row.item.time_to_ejecution_months} Meses`
                      : ""
                  }}
                </p>
              </template>
              <template v-slot:cell(time_to_claim)="row">
                <p class="m-0 p-0">
                  {{
                    row.item.time_to_claim_months != 0
                      ? row.item.time_to_claim_months == 1
                        ? `${row.item.time_to_claim_months} Mes`
                        : `${row.item.time_to_claim_months} Meses`
                      : ""
                  }}
                </p>
              </template>
              <template v-slot:cell(ejecution_date)="row">
                <p class="m-0 p-0">
                  {{ row.item.init_ejecution_task_date }} -
                  {{ row.item.end_ejecution_task_date }}
                </p>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <!-- <b-button
                    :id="`info-btn-${row.index}`"
                    variant="outline-info btn-transparent"
                    size="xs"
                    :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                    @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fe-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>
                  <b-tooltip
                    :target="`info-btn-${row.index}`"
                    triggers="hover"
                    variant="info"
                  >
                    {{ $t("detail") }}
                  </b-tooltip> -->
                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-warning btn-transparent"
                    size="xs"
                    @click="
                      () => {
                        createUpdateModalShow = true;
                        newItem = row.item;
                      }
                    "
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`update-btn-${row.index}`"
                    triggers="hover"
                    variant="warning"
                  >
                    {{ $t("edit") }}
                  </b-tooltip>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`delete-btn-${row.index}`"
                    triggers="hover"
                    variant="danger"
                  >
                    {{ $t("delete") }}
                  </b-tooltip>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- Detail modal -->
    <!-- <b-modal
      :id="detailModal.id"
      v-model="createUpdateModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
    >
      <table class="table-hover table-sm mb-0">
        <tr>
          <th style="text-align: right">{{ $t("name") }}</th>
          <td>{{ _.capitalize(detailModal.content.name) }}</td>
        </tr>
        <tr>
          <th style="text-align: right">{{ $t("description") }}</th>
          <td>
            {{
              detailModal.content.group_info
                ? detailModal.content.group_info.description
                : ""
            }}
          </td>
        </tr>
        <tr>
          <th style="text-align: right">{{ $t("permissions") }}</th>
          <td v-if="detailModal.content.permissions_info">
            <ul>
              <li
                v-for="(permission, index) in detailModal.content.permissions_info"
                :key="index"
              >
                {{ permission.name }}
              </li>
            </ul>
          </td>

          <td v-else>No tiene permisos asignados</td>
        </tr>
        <tr>
          <th style="text-align: right">Miembros</th>
          <td v-if="detailModal.content.users_set_info">
            <ul>
              <li
                v-for="(user, index) in detailModal.content.users_set_info"
                :key="index"
              >
                {{
                  user.first_name
                    ? `${user.first_name} ${user.last_name} (${user.username})`
                    : user.username
                }}
              </li>
            </ul>
          </td>

          <td v-else>No posee usuarios miembros</td>
        </tr>
      </table>
    </b-modal> -->
    <!-- Create-Update modal -->
    <b-modal
      :id="Math.random()"
      v-model="createUpdateModalShow"
      :title="'Tipos de Bonos'"
      :size="'lg'"
      class="shadow"
      hide-footer
    >
      <CuoponTypesCreateForm
        @close="createUpdateModalShow = false"
        :onFormSubmit="onFormSubmit"
        :newItem="newItem"
        :isSubmitting="isSubmitting"
      ></CuoponTypesCreateForm>
      <!-- <GroupsUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :form="updateForm"
      >
      </GroupsUpdateForm>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary rounded"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          type="submit"
          form="form"
          variant="primary rounded"
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : $v.updateForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t("submit") }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template> -->
    </b-modal>
    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      :title="`${$t('delete')} ${$t('Tipo de Bono')}`"
      :ok-title="$t('delete')"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteCouponType"
    >
      <p>
        {{ $t("are_sure_delete") }} el {{ $t("Tipo de Bono") }} {{ $t("named") }}
        {{ toDelete ? toDelete.name : "" }} ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-primary rounded shadow" @click="cancel">
          {{ $t("cancel") }}
        </b-button>
        <b-button
          size="sm"
          variant="danger rounded shadow"
          :disabled="isSubmitting"
          @click="ok"
        >
          <span v-if="!isSubmitting">
            {{ $t("delete") }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
